import { render } from "./IconItemCategoryFashion.vue?vue&type=template&id=3d6d78a0"
import script from "./IconItemCategoryFashion.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryFashion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__